import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="py-16 border-t border-[#c9a227]/10" 
      data-testid="footer"
      style={{ background: '#050505' }}
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <span 
              className="text-xl tracking-[0.3em] text-white/80"
              style={{ fontFamily: "'Cinzel', serif" }}
            >
              CELESTIAL MINDS
            </span>
            <p className="text-[#c9a227]/50 text-xs mt-1 tracking-wider">
              ™ Celestial Minds FZE
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-center md:text-right"
          >
            <p className="text-white/40 text-sm">
              © {currentYear} Celestial Minds FZE. All rights reserved.
            </p>
            <p className="text-white/30 text-xs mt-1">
              Dubai, United Arab Emirates
            </p>
          </motion.div>
        </div>

        {/* Divider */}
        <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#c9a227]/20 to-transparent mb-10" />

        {/* Legal Notes */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="space-y-6 text-white/40 text-xs leading-relaxed"
        >
          <p>
            <strong className="text-white/50">Disclaimer:</strong> The information provided on this website is for general informational purposes only. Celestial Minds FZE makes no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on the website.
          </p>
          
          <p>
            <strong className="text-white/50">Intellectual Property:</strong> All content, trademarks, and intellectual property displayed on this website are the property of Celestial Minds FZE unless otherwise stated. Unauthorized use, reproduction, or distribution of any content is strictly prohibited without prior written consent.
          </p>
          
          <p>
            <strong className="text-white/50">Investment Disclaimer:</strong> Nothing on this website constitutes an offer, solicitation, or recommendation to buy or sell any securities or financial instruments. Celestial Minds FZE does not provide investment advice. Any investment decisions should be made after conducting independent research and consulting with qualified financial advisors.
          </p>
          
          <p>
            <strong className="text-white/50">Contribution Terms:</strong> Contributions to Celestial Minds FZE are voluntary and do not constitute investments. They do not confer equity, ownership, governance rights, or any expectation of financial return. Contributions are non-refundable unless otherwise agreed in writing. By contributing, you acknowledge and accept these terms.
          </p>
          
          <p>
            <strong className="text-white/50">Limitation of Liability:</strong> To the fullest extent permitted by law, Celestial Minds FZE shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses.
          </p>
          
          <p>
            <strong className="text-white/50">Governing Law:</strong> These terms and conditions are governed by and construed in accordance with the laws of the United Arab Emirates. Any disputes arising out of or related to the use of this website shall be subject to the exclusive jurisdiction of the courts in Dubai, UAE.
          </p>
          
          <p>
            <strong className="text-white/50">Contact:</strong> For inquiries, please contact us at{' '}
            <a 
              href="mailto:invitation@celestialmindsfze.com" 
              className="text-[#c9a227]/70 hover:text-[#c9a227] transition-colors"
            >
              invitation@celestialmindsfze.com
            </a>
          </p>
        </motion.div>

        {/* Bottom Note */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-10 pt-6 border-t border-[#c9a227]/10 text-center"
        >
          <p className="text-white/30 text-xs">
            By using this website, you agree to these terms and conditions.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
